var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QS-h4-title',{attrs:{"slot":"header","title":"基本信息"},slot:"header"}),_vm._v(" "),_c('column-box',{attrs:{"list":_vm.list,"source":_vm.source,"labelWidth":130}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }